import type { DevScenario } from '@arya/shared/domain';
import type { MockApiErrorBody } from '@arya/shared/msw-cloudflare';
import { devScenarioRequest } from '@arya/shared/msw-cloudflare';

import { http, HttpResponse } from 'msw';

export const INVEST_RATE_LIMITED_SCENARIO: DevScenario = {
  name: 'invest-429',
  group: 'Invest',
  title: 'Rate limited',
  description: 'Confirming an investment answers 429: the dialog asks to retry in 30 s.',
  screen: '/market/projects/2?invest=2500',
};

export const investRateLimitedHandler = http.all(
  devScenarioRequest({ method: 'POST', path: '/api/market/projects/:projectId/invest' }, INVEST_RATE_LIMITED_SCENARIO),
  () => {
    const body: MockApiErrorBody = { error: { message: 'Too many requests', data: { retryAfter: 30 } } };
    return HttpResponse.json(body, { status: 429, headers: { 'Retry-After': '30' } });
  }
);
